import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { z as o } from "zod";
import { featureGroupBlueprint as f } from "./index-blueprint.es.js";
import { componentWrapperSchema as i, ComponentWrapper as x } from "@made-people/blueprint-component-wrapper";
import { responsiveImageSchema as N, ResponsiveImage as b } from "@made-people/blueprint-responsive-image";
import { withManagedProps as j } from "@made-people/managed-props";
import { withZod as v } from "@made-people/react-prop-guard";
import { useLink as y } from "@made-people/grease-link";
import "@made-people/blueprint";
const G = o.object({
  layout: i.shape.layout.optional(),
  variants: o.custom().optional(),
  items: o.array(
    o.object({
      icon: N.optional(),
      href: o.object({ href: o.string().optional() }).optional(),
      label: o.string().optional(),
      description: o.string().optional()
    })
  ).optional()
}).merge(i), B = j(
  "FeatureGroup",
  v(G, ({ layout: s, variants: m, items: a, ...c }) => {
    const t = f.styles(m), l = y();
    return /* @__PURE__ */ e(x, { layout: s, className: t.wrapper, ...c, children: a == null ? void 0 : a.map(({ icon: p, label: u, description: d, href: r }, g) => {
      const h = r != null && r.href ? l : "div";
      return /* @__PURE__ */ n(
        h,
        {
          className: t.item,
          href: (r == null ? void 0 : r.href) ?? "",
          children: [
            p && /* @__PURE__ */ e(b, { ...p, className: t.icon }),
            /* @__PURE__ */ n("div", { className: t.text, children: [
              /* @__PURE__ */ e("p", { className: t.textLabel, children: u }),
              /* @__PURE__ */ e("p", { className: t.textDescription, children: d })
            ] })
          ]
        },
        g
      );
    }) });
  })
);
export {
  B as FeatureGroup,
  G as featureGroupSchema
};
//# sourceMappingURL=index.es.js.map
